import { useCallback } from 'react';

export const useOpenUrl = (url: string | undefined) => {
  return useCallback(() => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, [url]);
};
